export default __webpack_public_path__ + "static/media/workshop-banner.5b08cf7b.jpeg";